module.exports = __webpack_public_path__ + "img/icon-onboarding.709460a8.svg";